// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plus {
  position: absolute;
  height: 2rem;
  width: 2rem;
  transition: 0.2s ease-in-out;
  margin: 0 auto;
  cursor: pointer;
  margin-left: 87%;
  /* margin: 1rem; */
  /* background: #ffb400 !important; */
  /* padding: ; */
}
.plus:hover {
  transform: rotate(45deg);
}
`, "",{"version":3,"sources":["webpack://./src/modules/private/containers/chatButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".plus {\r\n  position: absolute;\r\n  height: 2rem;\r\n  width: 2rem;\r\n  transition: 0.2s ease-in-out;\r\n  margin: 0 auto;\r\n  cursor: pointer;\r\n  margin-left: 87%;\r\n  /* margin: 1rem; */\r\n  /* background: #ffb400 !important; */\r\n  /* padding: ; */\r\n}\r\n.plus:hover {\r\n  transform: rotate(45deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
